<template>
  <div class="layout-wapper">
    <div class="layout-header" v-if="!isMicro && isNeedHeader" :style="{ height: headerHeight }">
      <slot name="header"></slot>
    </div>
    <div class="layout-box" :style="boxStyle">
      <div class="layout-sidebar" v-if="!isMicro">
        <slot name="sidebar"></slot>
      </div>
      <div class="layout-content" :class='{"layout-content-micro":isMicro}'>
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mbsLayout',
  props: {
    isNeedHeader: {
      type: Boolean,
      default: false,
    },
    headerHeight: {
      type: String,
      default: '60px',
    },
  },
  computed: {
    boxStyle() {
      // eslint-disable-next-line no-underscore-dangle
      if (window.__POWERED_BY_QIANKUN__) {
        return { height: '100%' };
      }
      // eslint-disable-next-line no-underscore-dangle
      return this.isNeedHeader ? { height: `calc(100vh - ${this.headerHeight})` } : { height: '100%' };
    },
    isMicro() {
      // console.log('sdfsfsfsfsf', window.__POWERED_BY_QIANKUN__);
      // eslint-disable-next-line no-underscore-dangle
      return window.__POWERED_BY_QIANKUN__;
    },
  },
};
</script>

<style lang="less">
.layout {
  &-wapper {
    overflow: hidden;
    height: 100%;
  }

  &-header {
    height: 60px;
  }

  &-box {
    display: flex;
  }

  &-sidebar {
    flex: 180px 0 0;
    width: 180px;
    height: 100%;
  }

  &-content {
    flex: 1;
    padding: 20px;
    height: 100%;
    overflow-y: auto;
  }
  &-content-micro {
    padding: 0;
  }
}
</style>
